const ratioByAspect = {
  "1:1": "1 / 1",
  "3:4": "3 / 4",
  "4:3": "4 / 3",
  "16:9": "16 / 9",
  "9:16": "9 / 16",
};

export function normalizeImageItem(image, index = 0) {
  const aspectRatio = image.aspectRatio || image.ar || "1:1";
  const ratio = image.ratioCss || image.ratio || ratioByAspect[aspectRatio] || ratioFromDimensions(image.width, image.height) || "1 / 1";
  const stats = image.stats || {};
  const viewerState = image.viewerState || {};
  return {
    ...image,
    tags: Array.isArray(image.tags) ? image.tags : [],
    author: image.author || { handle: "designer", name: "김디자인", nameEn: "Designer Kim", tone: "#FDDC06" },
    ar: aspectRatio,
    ratio,
    likes: numberOr(image.likes, stats.likes, 0),
    views: numberOr(image.views, stats.views, 0),
    saves: numberOr(image.saves, stats.saves, 0),
    liked: Boolean(viewerState.liked ?? image.liked),
    saved: Boolean(viewerState.saved ?? image.saved),
    createdDays: numberOr(image.createdDays, daysSince(image.createdAt), index + 1),
  };
}

export function normalizeImageItems(items) {
  return Array.isArray(items) ? items.map((item, index) => normalizeImageItem(item, index)) : [];
}

export function mergeImageItems(previous, next) {
  const byID = new Map();
  for (const item of previous || []) {
    if (item?.id) byID.set(item.id, item);
  }
  for (const item of next || []) {
    if (item?.id) byID.set(item.id, item);
  }
  return Array.from(byID.values());
}

function numberOr(...values) {
  for (const value of values) {
    if (typeof value === "number" && Number.isFinite(value)) return value;
  }
  return 0;
}

function ratioFromDimensions(width, height) {
  if (typeof width !== "number" || typeof height !== "number" || width <= 0 || height <= 0) return "";
  return `${width} / ${height}`;
}

function daysSince(value) {
  if (!value) return null;
  const time = Date.parse(value);
  if (!Number.isFinite(time)) return null;
  return Math.max(1, Math.round((Date.now() - time) / 86400000));
}

if (typeof window !== "undefined") {
  Object.assign(window, { normalizeImageItem, normalizeImageItems, mergeImageItems });
}
